import { render, staticRenderFns } from "./ShareStockTakeBottomSheet.vue?vue&type=template&id=6fabe0a1&scoped=true&lang=pug&"
import script from "./ShareStockTakeBottomSheet.vue?vue&type=script&lang=js&"
export * from "./ShareStockTakeBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./ShareStockTakeBottomSheet.vue?vue&type=style&index=0&id=6fabe0a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabe0a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomSheet,VBtn,VCard,VCol,VIcon,VRow,VSheet,VSpacer})
